
import React from "react";
import { LucideIcon } from "lucide-react";

interface PolicySectionProps {
  id: string;
  title: string;
  icon: React.ReactNode;
  number: string | number;
  children: React.ReactNode;
}

const PolicySection = ({ id, title, icon, number, children }: PolicySectionProps) => {
  return (
    <div id={id} className="bg-white rounded-xl shadow-md p-6 md:p-8 mb-8 transition-all hover:shadow-lg">
      <h2 className="flex items-center gap-3 text-elfGreen text-2xl font-semibold mb-4">
        <span className="flex items-center justify-center w-10 h-10 bg-elfGreen-light rounded-full text-elfGreen">
          {icon}
        </span>
        {number}. {title}
      </h2>
      <div className="pl-0 md:pl-12">
        {children}
      </div>
    </div>
  );
};

export default PolicySection;
